import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MortgageBroker, MortgageBrokerage } from '@models/brokerage';
import { Brokerage } from '@models/matter';
import { UntilDestroy } from '@ngneat/until-destroy';
import { MatterMortgageDispatch } from '@state/matter/matter_mortgages';

export interface MortgageBrokerModalData {
	brokerage: MortgageBrokerage;
	matterMortgageId: string;
	searchTerm?: string;
}

@UntilDestroy()
@Component({
	selector: 'app-mortgage-broker-modal',
	templateUrl: './mortgage-broker-modal.component.html',
	standalone: false,
})
export class MortgageBrokerModalComponent {
	public brokerage: Brokerage;
	public required = true;
	public firstName: string;
	public lastName: string;
	private matterMortgageId: string;
	constructor(
		public dialogRef: MatDialogRef<MortgageBrokerModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: MortgageBrokerModalData,
		private matterMortgageDispatch: MatterMortgageDispatch,
	) {
		this.firstName = data?.brokerage?.broker?.firstName ?? '';
		this.lastName = data?.brokerage?.broker?.lastName ?? '';
		this.brokerage = data?.brokerage;
		this.matterMortgageId = data.matterMortgageId;
	}

	onSubmit(mortgageBroker: MortgageBroker) {
		this.matterMortgageDispatch.CreateMortgageBroker(
			this.matterMortgageId,
			mortgageBroker,
			this.brokerage?.id,
		);
		this.dialogRef.close(mortgageBroker);
	}

	onCancel() {
		this.dialogRef.close();
	}
}
